import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mpro-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss'],
})
export class PasswordStrengthComponent implements OnChanges {
  @Input() currentPassword: string = '';
  @Output() passwordStrengthChange: EventEmitter<number> = new EventEmitter<number>();
  passwordStrength: number = 0;
  faCheck = faCheck;

  criteria = {
    lengthMet: false,
    hasUppercase: false,
    hasLowercase: false,
    hasNumber: false,
    hasSpecialChar: false,
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentPassword']) {
      this.evaluatePasswordStrength();
      this.passwordStrengthChange.emit(this.passwordStrength);
    }
  }

  evaluatePasswordStrength(): void {
    this.criteria.lengthMet = this.currentPassword.length >= 8;
    this.criteria.hasUppercase = /[A-Z]/.test(this.currentPassword);
    this.criteria.hasLowercase = /[a-z]/.test(this.currentPassword);
    this.criteria.hasNumber = /\d/.test(this.currentPassword);
    this.criteria.hasSpecialChar = /[\W_]/.test(this.currentPassword);

    // Update password strength based on criteria
    this.passwordStrength = 0;
    if (this.criteria.lengthMet) this.passwordStrength++;
    if (this.criteria.hasUppercase) this.passwordStrength++;
    if (this.criteria.hasLowercase) this.passwordStrength++;
    if (this.criteria.hasNumber) this.passwordStrength++;
    if (this.criteria.hasSpecialChar) this.passwordStrength++;
  }

  getPasswordStrengthDetails() {
    let strengthClass = 'progress-bar bg-secondary';
    let strengthText = '';
    let strengthColor = 'grey';

    if (!this.currentPassword) {
      return { strengthClass, strengthText, strengthColor };
    }

    switch (this.passwordStrength) {
      case 0:
      case 1:
        strengthClass = 'progress-bar bg-danger';
        strengthText = 'Poor';
        strengthColor = 'red';
        break;
      case 2:
        strengthClass = 'progress-bar bg-warning';
        strengthText = 'Weak';
        strengthColor = '#f06c2c';
        break;
      case 3:
      case 4:
        strengthClass = 'progress-bar bg-info';
        strengthText = 'Strong';
        strengthColor = '#007bff';
        break;
      case 5:
        strengthClass = 'progress-bar bg-success';
        strengthText = 'Excellent';
        strengthColor = 'green';
        break;
    }

    return { strengthClass, strengthText, strengthColor };
  }

  getProgressBarClass(): string {
    return this.getPasswordStrengthDetails().strengthClass;

  }

  getStrengthLabelText(): string {
    return this.getPasswordStrengthDetails().strengthText;
  }

  getStrengthLabelColor(): string {
    return this.getPasswordStrengthDetails().strengthColor;
  }

  getProgressBarWidth(): string {
    if (!this.currentPassword) {
      return '0%';
    }
    return `${(this.passwordStrength / 5) * 100}%`;
  }
}